import { useState, useEffect } from 'react';
import { Layout } from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../lib/supabase';
import { RecruitingView } from '../../components/RecruitingView';

const ELIGIBLE_GRADES = ['10th', '11th', '12th'];

export function AthleteRecruiting() {
  const { profile } = useAuth();
  const [eligible, setEligible] = useState(null); // null = loading

  useEffect(() => {
    if (profile) checkEligibility();
  }, [profile]);

  async function checkEligibility() {
    const [{ data: ap }, { data: billing }] = await Promise.all([
      supabase.from('athlete_profiles').select('grade_level').eq('id', profile.id).maybeSingle(),
      supabase.from('billing').select('tier, year, month').eq('athlete_id', profile.id)
        .order('year', { ascending: false }).order('month', { ascending: false }).limit(1),
    ]);
    const gradeOk = ap?.grade_level && ELIGIBLE_GRADES.includes(ap.grade_level);
    const tierOk = billing?.[0]?.tier === 'elite';
    setEligible(!!(gradeOk && tierOk));
  }

  if (eligible === null) {
    return (
      <Layout>
        <div className="loading-screen" style={{ minHeight: 200 }}>
          <div className="loading-dot-row">
            <div className="loading-dot" /><div className="loading-dot" /><div className="loading-dot" />
          </div>
        </div>
      </Layout>
    );
  }

  if (!eligible) {
    return (
      <Layout>
        <div style={{ marginBottom: 24 }}>
          <p className="page-eyebrow">Athlete</p>
          <h1 className="page-title">College Recruiting</h1>
        </div>
        <div className="empty-state">
          <p className="empty-state-title">Recruiting not available</p>
          <p className="empty-state-sub">
            Recruiting is available for athletes in 10th–12th grade on the Elite plan.
          </p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div style={{ marginBottom: 24 }}>
        <p className="page-eyebrow">Athlete</p>
        <h1 className="page-title">College Recruiting</h1>
      </div>
      <RecruitingView athleteId={profile.id} athleteName={profile.full_name} />
    </Layout>
  );
}
